import _debounce from 'lodash.debounce';

export const debounce = _debounce;
